import React from "react";
import ReactDOM from "react-dom";
import { Form, Icon, Input, Button, Row, Col, DatePicker } from "antd";
import moment from "moment";

const { TextArea } = Input;

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

export const ValidationFormStep3 = (props) => {
  if (props.currentStep !== "Step 3") {
    return null;
  }
  return (
    <div className="form-group">
      <h4 style={{ display: "inline-block !important" }}>
        Site ID:{" "}
        <h3 style={{ color: "#4CDEF5", display: "inline-block" }}>
          {props.siteID}
        </h3>
      </h4>
      <h4 style={{ display: "inline-block !important" }}>
        User ID:{" "}
        <h3 style={{ color: "#4CDEF5", display: "inline-block" }}>
          {props.userID}
        </h3>
      </h4>
      <h4 style={{ display: "inline-block !important" }}>
        Subject ID:{" "}
        <h3 style={{ color: "#4CDEF5", display: "inline-block" }}>
          {props.subjectID}
        </h3>
      </h4>
      <h4 style={{ display: "inline-block !important" }}>
        Validation Date:{" "}
        <h5 style={{ color: "#4CDEF5", display: "inline-block" }}>
          {props.validationExistsDate}
        </h5>
      </h4>

      <hr />
      <p> </p>
      <h3 style={{ display: "inline-block !important" }}>
        Randomization Information
      </h3>

      {props.validationExistsUsedRecommendedValues === "true" ? (
        <div>
          <p
            style={{
              display: "inline-block !important",
              textAlign: "center",
            }}
          >
            The information below is read-only as you indicated that you have
            used the recommended randomization values
          </p>
          <h4 style={{ display: "inline-block !important" }}>
            Randomization Date:{" "}
            <h5 style={{ color: "#4CDEF5", display: "inline-block" }}>
              {props.randomizationDate}
            </h5>
          </h4>
          <h4 style={{ display: "inline-block !important" }}>
            Drug allocated as per randomization administered:{" "}
            <h5 style={{ color: "#4CDEF5", display: "inline-block" }}>
              {props.validationExistsUsedRecommendedValues === "true" ? (
                <div>Yes</div>
              ) : (
                <div>No</div>
              )}
            </h5>
          </h4>
          <h4 style={{ display: "inline-block !important" }}>
            Validation Weight:{" "}
            <h5 style={{ color: "#4CDEF5", display: "inline-block" }}>
              {props.validationExistsWeight} kg
            </h5>
          </h4>

          <h4 style={{ display: "inline-block !important" }}>
            Validation Drug:{" "}
            <h2 style={{ color: "#4CDEF5", display: "inline-block" }}>
              {props.validationExistsGroup === "tpa"
                ? "Alteplase tPA"
                : "Tenecteplase tNK"}
            </h2>
          </h4>
          {props.validationExistsGroup === "tnk_tpa" ? (
            <h4
              style={{
                marginTop: "2rem",
                display: "inline-block !important",
              }}
            >
              Tenecteplase tNK Dose:{" "}
              <h2 style={{ color: "#4CDEF5", display: "inline-block" }}>
                {props.validationExistsTNKDose}
              </h2>
            </h4>
          ) : (
            <div>
              <h4
                style={{
                  marginTop: "2rem",
                  display: "inline-block !important",
                }}
              >
                Alteplase tPA Bolus Dose:{" "}
                <h2 style={{ color: "#4CDEF5", display: "inline-block" }}>
                  {props.validationExistsTPABolusDose}
                </h2>
              </h4>
              <h4
                style={{
                  marginTop: "2rem",
                  display: "inline-block !important",
                }}
              >
                Alteplase tPA Infusion Dose:{" "}
                <h2 style={{ color: "#4CDEF5", display: "inline-block" }}>
                  {props.validationExistsTPAInfusionDose}
                </h2>
              </h4>
            </div>
          )}

          <Form.Item>
            {props.getFieldDecorator("validationExistsComments", {
              initialValue: props.validationExistsComments,
              onChange: props.handleChange,
              rules: [
                {
                  required: false,
                  message: "Comments",
                },
              ],
            })(
              <label>
                <h5>Validation Comments</h5>
                <TextArea
                  id="validationExistsComments"
                  name="validationExistsComments"
                  prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
                  placeholder="Comments"
                  allowClear
                  autoFocus
                  size="large"
                  autoSize={{ minRows: 3, maxRows: 8 }}
                />
              </label>
            )}
          </Form.Item>
        </div>
      ) : (
        <div>
          <p
            style={{
              display: "inline-block !important",
              textAlign: "center",
            }}
          >
            Please enter the randomization values that were used and explain in
            the comments box why the recommended values were not used
          </p>
          <h4 style={{ display: "inline-block !important" }}>
            Randomization Date:{" "}
            <h5 style={{ color: "#4CDEF5", display: "inline-block" }}>
              {props.randomizationDate}
            </h5>
          </h4>
          <h4 style={{ display: "inline-block !important" }}>
            Drug allocated as per randomization administered:{" "}
            <h5 style={{ color: "#4CDEF5", display: "inline-block" }}>
              {props.validationExistsUsedRecommendedValues === "true" ? (
                <div>Yes</div>
              ) : (
                <div>No</div>
              )}
            </h5>
          </h4>

          <Form.Item>
            {props.getFieldDecorator("validationExistsWeight", {
              initialValue: props.validationExistsWeight,
              onChange: props.handleChange,
              rules: [
                {
                  required: true,
                  message: "Please input weight",
                },
                {
                  validator: (rule, value, callback) => {
                    if (value) {
                      try {
                        if (!Number.isInteger(+value) || !!~value.indexOf('.')) {
                          throw new Error();
                        }
                        callback();
                      } catch (err) {
                        callback(err);
                      }
                    } else {
                      callback();
                    }
                  },
                  message: "Whole numbers only",
                },
              ],
            })(
              <Input
                id="validationExistsWeight"
                name="validationExistsWeight"
                prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
                placeholder="Weight"
                allowClear
                autoFocus
                addonAfter="kg"
                size="large"
              />
            )}
          </Form.Item>

          <Form.Item>
            {props.getFieldDecorator("validationExistsGroup", {
              initialValue: props.validationExistsGroup,
              onChange: props.handleChange,
              rules: [
                {
                  required: true,
                  message: "Which drug was administered?",
                },
              ],
            })(
              <label>
                <h5>Which drug was administered?</h5>
                <select
                  id="validationExistsGroup"
                  name="validationExistsGroup"
                  size="large"
                  className="ant-input ant-input-lg"
                >
                  <option value="">Please select an option</option>
                  <option value="tpa">Alteplase tPA</option>
                  <option value="tnk_tpa">Tenecteplase tNK</option>
                </select>
              </label>
            )}
          </Form.Item>

          <div
            id="tnkDosageInformation"
            style={
              props.validationExistsGroup !== "tnk_tpa"
                ? { display: "none" }
                : { display: "block" }
            }
          >
            <p
              style={{
                display: "inline-block !important",
                textAlign: "center",
              }}
            >
              Note: Only enter the below information if you administered
              Tenecteplase tNK
            </p>

            <Form.Item>
              {props.getFieldDecorator("validationExistsTNKDose", {
                initialValue: props.validationExistsTNKDose,
                onChange: props.handleChange,
                rules: [
                  {
                    required: false,
                    message:
                      "Please enter the Tenecteplase tNK dose that was administered",
                  },
                ],
              })(
                <Input
                  id="validationExistsTNKDose"
                  name="validationExistsTNKDose"
                  prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
                  placeholder="Please enter the Tenecteplase tNK dose that was administered"
                  allowClear
                  addonAfter="x.x ml"
                  size="large"
                />
              )}
            </Form.Item>
          </div>

          <div
            id="tpaDosageInformation"
            style={
              props.validationExistsGroup !== "tpa"
                ? { display: "none" }
                : { display: "block" }
            }
          >
            <p
              style={{
                display: "inline-block !important",
                textAlign: "center",
              }}
            >
              Note: Only enter the below information if you administered
              Alteplase tPA
            </p>

            <Form.Item>
              {props.getFieldDecorator("validationExistsTPABolusDose", {
                initialValue: props.validationExistsTPABolusDose,
                onChange: props.handleChange,
                rules: [
                  {
                    required: false,
                    message:
                      "Please enter the Alteplase tPA bolus dose that was administered",
                  },
                ],
              })(
                <Input
                  id="validationExistsTPABolusDose"
                  name="validationExistsTPABolusDose"
                  prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
                  placeholder="Please enter the Alteplase tPA bolus dose that was administered"
                  allowClear
                  addonAfter="x.x ml"
                  size="large"
                />
              )}
            </Form.Item>

            <Form.Item>
              {props.getFieldDecorator("validationExistsTPAInfusionDose", {
                initialValue: props.validationExistsTPAInfusionDose,
                onChange: props.handleChange,
                rules: [
                  {
                    required: false,
                    message:
                      "Please enter the Alteplase tPA infusion dose that was administered",
                  },
                ],
              })(
                <Input
                  id="validationExistsTPAInfusionDose"
                  name="validationExistsTPAInfusionDose"
                  prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
                  placeholder="Please enter the Alteplase tPA infusion dose that was administered"
                  allowClear
                  addonAfter="xx ml over 1 hour"
                  size="large"
                />
              )}
            </Form.Item>
          </div>

          <Form.Item>
            {props.getFieldDecorator("validationExistsComments", {
              initialValue: props.validationExistsComments,
              onChange: props.handleChange,
              rules: [
                {
                  required: true,
                  message:
                    "Please explain in the comments box why the administered drug differs from the randomization allocation drug!",
                },
              ],
            })(
              <label>
                <h5>Validation Comments</h5>
                <TextArea
                  id="validationExistsComments"
                  name="validationExistsComments"
                  prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
                  placeholder="Please explain in the comments box why the administered drug differs from the randomization allocation drug!"
                  allowClear
                  size="large"
                  autoSize={{ minRows: 3, maxRows: 8 }}
                />
              </label>
            )}
          </Form.Item>
        </div>
      )}
      <hr />
      <p> </p>
      <h3 style={{ display: "inline-block !important" }}>Deviation Details</h3>
      {props.validationExistsDeviationOccurred === "true" ? (
        <div>
          <p
            style={{
              display: "inline-block !important",
              textAlign: "center",
            }}
          >
            You have indicated that other deviation from the protocol has
            occured
          </p>
          <Form.Item>
            {props.getFieldDecorator("validationDeviationExistsComments", {
              initialValue: props.validationDeviationExistsComments,
              onChange: props.handleChange,
              rules: [
                {
                  required: true,
                  message: "Please provide deviation comments",
                },
              ],
            })(
              <label>
                <h5>Deviation Comments</h5>
                <TextArea
                  id="validationDeviationExistsComments"
                  name="validationDeviationExistsComments"
                  prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
                  placeholder="Comments"
                  allowClear
                  autoFocus
                  size="large"
                  autoSize={{ minRows: 3, maxRows: 8 }}
                />
              </label>
            )}
          </Form.Item>
        </div>
      ) : (
        <div>
          <p
            style={{
              display: "inline-block !important",
              textAlign: "center",
            }}
          >
            You have indicated that no other deviation from the protocol has
            occured
          </p>
        </div>
      )}

      <hr />
      <p> </p>
      <h3 style={{ display: "inline-block !important" }}>Vial Information</h3>

      <Form.Item>
        {props.getFieldDecorator("validationExistsVialNumber", {
          initialValue: props.validationExistsVialNumber,
          onChange: props.handleChange,
          rules: [
            {
              required: false,
              message: "Please enter the drug lot number",
            },
          ],
        })(
          <Input
            id="validationExistsVialNumber"
            name="validationExistsVialNumber"
            prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
            placeholder="Please enter the drug lot number"
            allowClear
            size="large"
          />
        )}
      </Form.Item>

      {props.getFieldValue("validationExistsVialNumber") && (
        <Form.Item>
          {props.getFieldDecorator("validationExistsVialExpiryDate", {
            initialValue: props.validationExistsVialExpiryDateMoment,
            onChange: props.handleVialExpiryDatePickerChange,
            rules: [
              {
                required: false,
                message: "Please enter the drug vial expiry date",
              },
            ],
          })(
            <MonthPicker
              id="validationExistsVialExpiryDate"
              name="validationExistsVialExpiryDate"
              prefix={<Icon type="user" style={{ color: "#FAFAFA" }} />}
              placeholder="Please enter the drug vial expiry date"
              allowClear
              size="large"
              className="ant-input ant-input-lg"
            />
          )}
        </Form.Item>
      )}

      <hr />
      <p> </p>
      <h3 style={{ display: "inline-block !important" }}>Validation Options</h3>

      <Form.Item>
        {props.getFieldDecorator("validationProvided", {
          initialValue: props.validationProvided,
          onChange: props.handleChange,
          rules: [
            {
              required: true,
              message:
                "Do you confirm that the information presented above is correct and agree to validate the randomization information for this subject?",
            },
          ],
        })(
          <label>
            <h5>
              Do you confirm that the information presented above is correct and
              agree to validate the randomization information for this subject?
              If no, please click on the Back button!
            </h5>
            <select
              id="validationProvided"
              name="validationProvided"
              size="large"
              className="ant-input ant-input-lg"
            >
              <option value="">Accept Validation?</option>
              <option value="yes">Yes</option>
              <option value="">No</option>
            </select>
          </label>
        )}
      </Form.Item>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/Step3.js